
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
h1, h2, h3, h4, h5, h6 {
  margin:0px;
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3, :host([site='BH']) h5, :host([site='BH']) h6 {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3 {
  font-weight:var(--fw-light);
}

:host([site='BH']) h5, :host([site='BH']) h6 {
  font-weight:var(--fw-bold);
}

:host([site='BH']) h1 {
  font-size:var(--bh-fs-heading-07);
  line-height:var(--bh-lh-heading-07);
  letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h2 {
  font-size:var(--bh-fs-heading-06);
  line-height:var(--bh-lh-heading-06);
  letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h3 {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h4 {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) h4 {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h4 {
  font-weight:var(--fw-normal);
}

:host([site='BH']) h5 {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h6 {
  font-size:var(--bh-fs-heading-02);
  line-height:var(--bh-lh-heading-02);
  letter-spacing:var(--bh-ls-heading-02);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3 {
  font-weight:var(--fw-light);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
  font-weight:var(--fw-bold);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h6.outline-font--h1 {
  font-size:var(--bh-fs-heading-07);
  line-height:var(--bh-lh-heading-07);
  letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h1.outline-font--h2, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h6.outline-font--h2 {
  font-size:var(--bh-fs-heading-06);
  line-height:var(--bh-lh-heading-06);
  letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h3 {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-weight:var(--fw-normal);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h6.outline-font--h5 {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h6 {
  font-size:var(--bh-fs-heading-02);
  line-height:var(--bh-lh-heading-02);
  letter-spacing:var(--bh-ls-heading-02);
}

:host([site='GHS']) h1, :host([site='GHS']) h2, :host([site='GHS']) h3, :host([site='GHS']) h4, :host([site='GHS']) h5, :host([site='GHS']) h6 {
  font-family:var(--ff-display);
}

h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
  font-size:var(--fs-h1-small);
  line-height:var(--lh-h1-small);
}

@media (min-width: 768px) {

  h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
    font-size:var(--fs-h1-medium);
    line-height:var(--lh-h1-medium);
  }
}

@media (min-width: 1024px) {

  h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
    font-size:var(--fs-h1);
    line-height:var(--lh-h1);
  }
}

h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
  font-size:var(--fs-h2-small);
  line-height:var(--lh-h2-small);
}

@media (min-width: 768px) {

  h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
    font-size:var(--fs-h2-medium);
    line-height:var(--lh-h2-medium);
  }
}

@media (min-width: 1024px) {

  h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
    font-size:var(--fs-h2);
    line-height:var(--lh-h2);
  }
}

h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
  font-size:var(--fs-h3-small);
  line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

  h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
    font-size:var(--fs-h3-medium);
    line-height:var(--lh-h3-medium);
  }
}

@media (min-width: 1024px) {

  h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}

h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

  h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
    font-size:var(--fs-h4-medium);
    line-height:var(--lh-h4-medium);
  }
}

@media (min-width: 1024px) {

  h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
    font-size:var(--fs-h4);
    line-height:var(--lh-h4);
  }
}

h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
  font-size:var(--fs-h5-small);
  line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

  h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
    font-size:var(--fs-h5-medium);
    line-height:var(--lh-h5-medium);
  }
}

@media (min-width: 1024px) {

  h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
    font-size:var(--fs-h5);
    line-height:var(--lh-h5);
  }
}

h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
  font-size:var(--fs-h6-small);
  line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

  h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
    font-size:var(--fs-h6-medium);
    line-height:var(--lh-h6-medium);
  }
}

@media (min-width: 1024px) {

  h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }
}

.outline-text--base {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--xs {
  font-size:var(--fs-xs) !important;
  line-height:var(--lh-xs) !important;
}

.outline-text--sm {
  font-size:var(--fs-sm) !important;
  line-height:var(--lh-sm) !important;
}

.outline-text--lg {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--lg.mobile {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--xl {
  font-size:var(--fs-xl) !important;
  line-height:var(--lh-xl) !important;
}

.outline-text--xl.mobile {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--2xl {
  font-size:var(--fs-2xl) !important;
  line-height:var(--lh-2xl) !important;
}

.outline-text--2xl.mobile {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--3xl {
  font-size:var(--fs-3xl) !important;
  line-height:var(--lh-3xl) !important;
}

.outline-text--3xl.mobile {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--4xl {
  font-size:var(--fs-4xl) !important;
  line-height:var(--lh-4xl) !important;
}

.outline-text--4xl.mobile {
  font-size:var(--fs-xl) !important;
  line-height:var(--lh-xl) !important;
}

.outline-text--5xl {
  font-size:var(--fs-5xl) !important;
  line-height:var(--lh-5xl) !important;
}

.outline-text--5xl.mobile {
  font-size:var(--fs-2xl) !important;
  line-height:var(--lh-2xl) !important;
}

.outline-text--6xl {
  font-size:var(--fs-6xl) !important;
  line-height:var(--lh-6xl) !important;
}

.outline-text--6xl.mobile {
  font-size:var(--fs-3xl) !important;
  line-height:var(--lh-3xl) !important;
}

.outline-text--7xl {
  font-size:var(--fs-7xl) !important;
  line-height:var(--lh-7xl) !important;
}

.outline-text--7xl.mobile {
  font-size:var(--fs-4xl) !important;
  line-height:var(--lh-4xl) !important;
}

.outline-text--8xl {
  font-size:var(--fs-8xl) !important;
  line-height:var(--lh-8xl) !important;
}

.outline-text--8xl.mobile {
  font-size:var(--fs-5xl) !important;
  line-height:var(--lh-5xl) !important;
}

.outline-text--9xl {
  font-size:var(--fs-9xl) !important;
  line-height:var(--lh-9lx) !important;
}

.outline-text--9xl.mobile {
  font-size:var(--fs-6xl) !important;
  line-height:var(--lh-6xl) !important;
}

.outline-font--thin {
  font-weight:var(--fw-extralight);
}

.outline-font--extralight {
  font-weight:var(--fw-thin);
}

.outline-font--light {
  font-weight:var(--fw-light);
}

.outline-font--normal {
  font-weight:var(--fw-normal);
}

.outline-font--semibold {
  font-weight:var(--fw-semibold);
}

.outline-font--bold {
  font-weight:var(--fw-bold);
}

.outline-font--extrabold {
  font-weight:var(--fw-extrabold);
}

.outline-font--black {
  font-weight:var(--fw-black);
}

.btn {
  display:flex;
  cursor:pointer;
  align-items:center;
  border-radius:10px;
  border-width:0px;
  font-weight:var(--fw-semibold);
  line-height:1.25;
  text-decoration-line:none;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  min-width:44px;
}

.btn:focus{
    outline-width:1px;
    outline-style:dashed;
    outline-offset:4px;
  }

.btn:not(.cta-dark, .cta-light) {
  background-color:var(--bh-neutral-light);
}

.btn:not(.cta-dark, .cta-light) {
  color:var(--bh-neutral-white);
}

.btn:not(.cta-dark, .cta-light):hover, .btn:not(.cta-dark, .cta-light):focus {
  background-color:var(--bh-neutral-default);
}

.btn:not(.cta-dark, .cta-light):focus {
  outline-color:var(--bh-neutral-default);
}

.btn.parent-container-fit {
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
}

.btn.parent-container-fit .left, .btn.parent-container-fit .right {
  margin-bottom:0px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-top:0px;
}

.btn.parent-container-fit.justify-between{
  justify-content:space-between;
}

.btn.border-bottom-radius {
  border-bottom-left-radius:0px;
  border-bottom-right-radius:0px;
}

.btn ghs-icon {
  position:relative;
  margin-left:0.5rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

.btn.chip {
  border-radius:0.375rem;
  border-width:1px;
  border-style:solid;
  font-weight:var(--fw-normal);
}

.btn.chip .right ghs-icon {
  margin-left:0px;
}

.btn.chip:focus {
  outline-style:solid;
}

.btn.chip:focus {
  outline-width:2px;
}

.btn.chip.small {
  height:30px;
}

.btn.chip.small {
  padding-left:0.375rem;
  padding-right:0.375rem;
}

.btn.chip.small {
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

.btn.chip.small .right {
  padding-left:0.5rem;
}

.btn.chip.medium {
  height:37px;
}

.btn.chip.medium {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.btn.chip.medium .right {
  padding-left:0.625rem;
}

.btn.chip.large {
  height:43px;
}

.btn.chip.large {
  padding-left:1rem;
  padding-right:1rem;
}

.btn.chip.large .right {
  padding-left:0.75rem;
}

.btn.none {
  display:flex;
  align-items:center;
  padding-left:1rem;
  padding-right:1rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.left {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
}

.top {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
  padding-bottom:0.5rem;
}

.right {
  display:flex;
  height:100%;
  align-items:center;
  padding-left:0.5rem;
}

.btn[aria-disabled='true'] {
  pointer-events:none !important;
  cursor:not-allowed !important;
  background-color:var(--neutral-gray-4) !important;
  color:var(--neutral-gray-1) !important;
}

.btn.small {
  max-height:45px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.medium {
  max-height:55px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.large {
  min-height:45px;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px) {

  .btn.large {
    min-height:max-content;
  }

  .btn.large {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.large {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.large {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.btn.xl {
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {

  .btn.xl {
    min-height:max-content;
  }

  .btn.xl {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.xl {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.xl {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.btn.cta-dark.small, .btn.cta-light.small, .btn.cta-dark.large, .btn.cta-light.large {
  padding:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  min-height:auto;
}

.btn:has(> .top) {
  flex-direction:column;
  align-items:center;
  text-align:center;
}

[site='GHS'] .btn, :host([site='GHS']) .btn {
  font-family:var(--ff-display);
}

[site='GHS'] .btn.primary, [site='GHS'] .btn.secondary, [site='GHS'] .btn.tertiary, [site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.primary, :host([site='GHS']) .btn.secondary, :host([site='GHS']) .btn.tertiary, :host([site='GHS']) .btn.quaternary {
  transition-property:box-shadow;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.tertiary:hover, [site='GHS'] .btn.quaternary:hover, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.tertiary:hover, :host([site='GHS']) .btn.quaternary:hover{
      box-shadow:var(--brand-shadow-sm);
    }

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  color:var(--primary-blue);
}

[site='GHS'] .btn.tertiary:focus, :host([site='GHS']) .btn.tertiary:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  text-align:left;
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  text-align:left;
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.quaternary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white:focus, :host([site='GHS']) .btn.quaternary.border-white:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  color:var(--primary-blue);
}

[site='GHS'] .btn.quaternary.border-blue:focus, :host([site='GHS']) .btn.quaternary.border-blue:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta:focus, :host([site='GHS']) .btn.quaternary.border-magenta:focus {
  outline-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green:focus, :host([site='GHS']) .btn.quaternary.border-green:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary.text-white, :host([site='GHS']) .btn.tertiary.text-white {
  color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary.text-blue, :host([site='GHS']) .btn.tertiary.text-blue {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.tertiary.text-magenta, :host([site='GHS']) .btn.tertiary.text-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.tertiary.text-green, :host([site='GHS']) .btn.tertiary.text-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  min-height:6.5rem;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-radius:0px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-width:2px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-style:solid;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  background-color:var(--primary-blue);
}

@media (min-width: 768px) {

  [site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
    min-height:7.5rem;
  }
}

[site='GHS'] .btn.primary.border-square:hover, :host([site='GHS']) .btn.primary.border-square:hover {
  text-decoration-line:underline;
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-family:var(--bh-ff-body);
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl {
  font-weight:var(--fw-light);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl{
      font-size:clamp(1.5rem, calc(0rem + 3.13vw), 2rem);
      line-height:110%;
      letter-spacing:-0.16px;
    }

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.primary:hover, [site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:hover, :host([site='BH']) .btn.primary:focus {
  background-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-style:solid;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-width:2px;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  background-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  color:var(--bh-neutral-white) !important;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-width:2px;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-style:solid;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-style:solid;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-width:2px;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  border-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.tertiary:hover, [site='BH'] .btn.tertiary:focus, [site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:active {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:hover {
  background-color:var(--bh-brand-primary-lighter);
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-style:solid;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-width:2px;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  background-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  color:var(--bh-neutral-darker) !important;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-width:2px;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-style:solid;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-style:solid;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-width:2px;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  background-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.cta-dark, :host([site='BH']) .btn.cta-dark {
  color:var(--bh-brand-primary-default-compatibility);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.cta-light, :host([site='BH']) .btn.cta-light {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light:hover, [site='BH'] .btn.cta-light:active, [site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:hover, :host([site='BH']) .btn.cta-light:active, :host([site='BH']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  color:var(--bh-neutral-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.chip:focus, :host([site='BH']) .btn.chip:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  background-color:var(--bh-neutral-lighter) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  background-color:var(--eh-brand-secondary-100);
}

[site='BH'] .btn.emplify:hover, [site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:hover, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:hover, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:hover, :host([site='GHS']) .btn.emplify:focus {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify:hover,
    [site='BH'] .btn.emplify:focus,
    :host([site='BH']) .btn.emplify:hover,
    :host([site='BH']) .btn.emplify:focus,
    [site='GHS'] .btn.emplify:hover,
    [site='GHS'] .btn.emplify:focus,
    :host([site='GHS']) .btn.emplify:hover,
    :host([site='GHS']) .btn.emplify:focus{
      color:#fff;
    }

[site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:focus {
  outline-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify .right:has(> .extra-icon), :host([site='BH']) .btn.emplify .right:has(> .extra-icon), [site='GHS'] .btn.emplify .right:has(> .extra-icon), :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplify .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplify.small, :host([site='BH']) .btn.emplify.small, [site='GHS'] .btn.emplify.small, :host([site='GHS']) .btn.emplify.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew .right:has(> .extra-icon), [site='BH'] .btn.bellinmychart .right:has(> .extra-icon), [site='BH'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon), :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifynew .right:has(> .extra-icon), [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon), :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplifynew.small, [site='BH'] .btn.bellinmychart.small, [site='BH'] .btn.emplifymychart.small, :host([site='BH']) .btn.emplifynew.small, :host([site='BH']) .btn.bellinmychart.small, :host([site='BH']) .btn.emplifymychart.small, [site='GHS'] .btn.emplifynew.small, [site='GHS'] .btn.bellinmychart.small, [site='GHS'] .btn.emplifymychart.small, :host([site='GHS']) .btn.emplifynew.small, :host([site='GHS']) .btn.bellinmychart.small, :host([site='GHS']) .btn.emplifymychart.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew, :host([site='BH']) .btn.emplifynew, [site='GHS'] .btn.emplifynew, :host([site='GHS']) .btn.emplifynew {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover, [site='BH'] .btn.emplifynew:focus, :host([site='BH']) .btn.emplifynew:hover, :host([site='BH']) .btn.emplifynew:focus, [site='GHS'] .btn.emplifynew:hover, [site='GHS'] .btn.emplifynew:focus, :host([site='GHS']) .btn.emplifynew:hover, :host([site='GHS']) .btn.emplifynew:focus {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover,
    [site='BH'] .btn.emplifynew:focus,
    :host([site='BH']) .btn.emplifynew:hover,
    :host([site='BH']) .btn.emplifynew:focus,
    [site='GHS'] .btn.emplifynew:hover,
    [site='GHS'] .btn.emplifynew:focus,
    :host([site='GHS']) .btn.emplifynew:hover,
    :host([site='GHS']) .btn.emplifynew:focus{
      background-color:#fff;
    }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    background-color:transparent;
    color:#fff;
  }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    font-size:var(--fs-xs);
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    background-color:transparent;
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  padding:0px;
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    font-size:var(--fs-sm);
  }

.site--GHS.styled-text {
  font-family:var(--ff-body);
}

.site--GHS.styled-text--hero {
  font-family:var(--ff-display);
}

.site--GHS.styled-text--hero {
  font-weight:var(--fw-medium);
}

.site--GHS.styled-text a:not(.btn), .site--GHS.styled-text p a:not(.btn), .site--GHS.styled-text li a:not(.btn) {
  color:var(--primary-blue-light-2);
}

.site--GHS.styled-text a:not(.btn):hover, .site--GHS.styled-text a:not(.btn):focus, .site--GHS.styled-text p a:not(.btn):hover, .site--GHS.styled-text p a:not(.btn):focus, .site--GHS.styled-text li a:not(.btn):hover, .site--GHS.styled-text li a:not(.btn):focus {
  background-color:var(--primary-blue-light-2);
}

.site--GHS.styled-text a:not(.btn):hover, .site--GHS.styled-text a:not(.btn):focus, .site--GHS.styled-text p a:not(.btn):hover, .site--GHS.styled-text p a:not(.btn):focus, .site--GHS.styled-text li a:not(.btn):hover, .site--GHS.styled-text li a:not(.btn):focus {
  color:var(--neutral-white);
}

.site--GHS.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  background-color:var(--primary-green);
}

.site--GHS.styled-text ul.list-check-mark > li:before{
          background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%2300665E'/%3E%3C/svg%3E%0A");
        }

.site--GHS.styled-text ul.list-x-mark > li {
  padding-left:1.75rem;
}

.site--GHS.styled-text ul.list-x-mark > li:before {
  top:0.375rem;
}

.site--GHS.styled-text ul.list-x-mark > li:before{
        background-image:url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6672 1.22549C14.2235 0.781803 13.5068 0.781803 13.0631 1.22549L7.5 6.77725L1.93686 1.21411C1.49317 0.770426 0.776451 0.770426 0.332765 1.21411C-0.110922 1.6578 -0.110922 2.37452 0.332765 2.81821L5.89591 8.38135L0.332765 13.9445C-0.110922 14.3882 -0.110922 15.1049 0.332765 15.5486C0.776451 15.9923 1.49317 15.9923 1.93686 15.5486L7.5 9.98544L13.0631 15.5486C13.5068 15.9923 14.2235 15.9923 14.6672 15.5486C15.1109 15.1049 15.1109 14.3882 14.6672 13.9445L9.1041 8.38135L14.6672 2.81821C15.0995 2.3859 15.0995 1.6578 14.6672 1.22549Z' fill='%2300665E'/%3E%3C/svg%3E%0A");
      }

.site--GHS.styled-text ol > li::before {
  color:var(--primary-green);
}

.site--GHS.styled-text hr {
  border-color:var(--neutral-gray-4);
}

.site--GHS.styled-text blockquote {
  font-weight:var(--fw-semibold);
}

.site--GHS.styled-text blockquote {
  color:var(--primary-blue);
}

.site--GHS.styled-text blockquote {
  border-top-right-radius:1rem;
  border-bottom-right-radius:1rem;
}

.site--GHS.styled-text blockquote {
  border-color:var(--primary-blue);
}

.site--GHS.styled-text blockquote {
  background-color:var(--neutral-white);
}

.site--GHS.styled-text blockquote::before {
  position:absolute;
}

.site--GHS.styled-text blockquote::before {
  top:-2rem;
}

.site--GHS.styled-text blockquote::before {
  left:1.5rem;
}

.site--GHS.styled-text blockquote::before {
  background-color:var(--neutral-white);
}

.site--GHS.styled-text blockquote::before {
  background-position:center;
}

.site--GHS.styled-text blockquote::before {
  padding-left:1rem;
  padding-right:1rem;
}

@media (min-width: 768px) {

  .site--GHS.styled-text blockquote::before {
    top:-2rem;
  }
}

@media (min-width: 768px) {

  .site--GHS.styled-text blockquote::before {
    left:2.5rem;
  }
}

.site--GHS.styled-text blockquote::before{

      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 116 50.73' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath fill='%23ffffff00' d='M-20-18h160v89H-20z'%3E%3C/path%3E%3Cpath d='M71.019 50.432c-.438.295-1.532.555-2.172-.155l-1.182-1.487c-.573-.967.12-1.865.567-2.25 2.133-1.766 3.682-3.133 4.648-4.103 1.897-2 3.3-4 4.227-5.98.21-.456-.33-.75-.61-.838C69.499 33.329 66 29.29 66 23.505c0-3.41 1.132-6.178 3.397-8.307 2.264-2.13 5.096-3.195 8.497-3.197 3.052.008 5.745 1.397 8.078 4.166 2.299 2.616 3.448 5.439 3.446 8.468 0 8.897-6.133 17.496-18.4 25.797zm26.602 0c-.438.295-1.533.555-2.172-.155l-1.182-1.487c-.573-.967.119-1.865.567-2.25 2.131-1.766 3.68-3.133 4.648-4.103 1.897-2 3.299-4 4.227-5.98.21-.456-.33-.75-.61-.838-6.998-2.29-10.497-6.327-10.497-12.114 0-3.41 1.132-6.178 3.396-8.307 2.265-2.13 5.097-3.195 8.498-3.197 3.037 0 5.727 1.385 8.068 4.154 2.292 2.609 3.438 5.43 3.436 8.467.013 8.906-6.113 17.51-18.379 25.81zM44.981.3c.438-.295 1.533-.555 2.172.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.133 1.766-3.682 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838C46.501 17.403 50 21.44 50 27.227c0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.052-.01-5.745-1.398-8.078-4.167-2.299-2.616-3.448-5.438-3.446-8.467C26.582 17.2 32.715 8.6 44.982.3zM18.38.3c.437-.295 1.531-.555 2.171.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.13 1.766-3.68 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838 6.998 2.289 10.497 6.327 10.497 12.113 0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.037 0-5.727-1.385-8.068-4.154C1.144 31.968-.002 29.146 0 26.11-.013 17.205 6.113 8.6 18.38.3z' fill='%231b365d'%3E%3C/path%3E%3C/svg%3E");
      background-size:80%;
    }

.site--GHS.styled-text blockquote .author {
  font-weight:var(--fw-bold);
}

.site--GHS.styled-text blockquote .author {
  color:var(--neutral-gray-1);
}

.site--GHS.styled-text blockquote .author::before {
  display:inline-block;
}

.site--GHS.styled-text blockquote .author::before {
  height:0.25rem;
}

.site--GHS.styled-text blockquote .author::before {
  width:1.25rem;
}

.site--GHS.styled-text blockquote .author::before {
  border-width:0px;
}

.site--GHS.styled-text blockquote .author::before {
  border-bottom-width:1px;
}

.site--GHS.styled-text blockquote .author::before {
  border-style:solid;
}

.site--GHS.styled-text blockquote .author::before{
        content:'';
      }

.site--GHS.styled-text .table-wrapper::-webkit-scrollbar-track {
  background-color:var(--neutral-gray-4);
}

.site--GHS.styled-text .table-wrapper::-webkit-scrollbar-thumb {
  background-color:var(--primary-blue);
}

.site--GHS.styled-text .table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color:var(--primary-blue-light-1);
}

.site--GHS.styled-text .btn.cta-dark:hover {
  color:var(--primary-blue-dark);
}

p, h1, h2, h3, h4, ul, ol, ghs-image, figure, table {
  margin-bottom:1rem;
}

@media (min-width: 1280px) {

  p, h1, h2, h3, h4, ul, ol, ghs-image, figure, table {
    margin-bottom:2rem;
  }
}

h1, h2, h3, h4 {
  font-weight:var(--fw-bold);
}

h5, h6 {
  margin-bottom:1rem;
  font-weight:var(--fw-bold);
}

a:not(.btn), p a:not(.btn), li a:not(.btn) {
  text-decoration-line:underline;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:500ms;
}

a:not(.btn):hover, a:not(.btn):focus, p a:not(.btn):hover, p a:not(.btn):focus, li a:not(.btn):hover, li a:not(.btn):focus {
  text-decoration-line:none;
}

ol, ul {
  list-style-type:none;
  counter-reset:ol-counter;
}

ul ul, ol ol, ul ol, ol ul {
  margin-top:0.5rem;
}

@media (min-width: 1024px) {

  ul ul, ol ol, ul ol, ol ul {
    margin-top:1rem;
  }
}

ul > li {
  padding-left:1.25rem;
}

ul > li, ol > li {
  position:relative;
  margin-bottom:.35rem;
}

@media (min-width: 1024px) {

  ul > li, ol > li {
    margin-bottom:0.5rem;
  }
}

ul:not(.list-x-mark, .list-check-mark) > li:before {
  position:absolute;
  top:0.5rem;
  left:0px;
  margin-right:0.75rem;
  display:block;
  height:0.5rem;
  width:0.5rem;
  border-radius:9999px;
  content:'';
}

li > ul, li > ol {
  margin-bottom:0px;
}

ul.list-check-mark > li {
  padding-left:2.25rem;
}

ul.list-check-mark > li:before {
  position:absolute;
}

ul.list-check-mark > li:before {
  top:0.25rem;
}

ul.list-check-mark > li:before {
  left:0px;
}

ul.list-check-mark > li:before {
  display:block;
}

ul.list-check-mark > li:before {
  height:1.5rem;
}

ul.list-check-mark > li:before {
  width:1.5rem;
}

ul.list-check-mark > li:before {
  background-repeat:no-repeat;
}

ul.list-check-mark > li:before{

      content:'';
      background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23000'/%3E%3C/svg%3E%0A");
    }

ul.list-x-mark > li {
  padding-left:1.75rem;
}

ul.list-x-mark > li:before {
  position:absolute;
}

ul.list-x-mark > li:before {
  top:0.25rem;
}

ul.list-x-mark > li:before {
  left:0px;
}

ul.list-x-mark > li:before {
  display:block;
}

ul.list-x-mark > li:before {
  height:1.5rem;
}

ul.list-x-mark > li:before {
  width:1.5rem;
}

ul.list-x-mark > li:before {
  background-repeat:no-repeat;
}

ul.list-x-mark > li:before{

      content:'';
      background-image:url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6672 1.22549C14.2235 0.781803 13.5068 0.781803 13.0631 1.22549L7.5 6.77725L1.93686 1.21411C1.49317 0.770426 0.776451 0.770426 0.332765 1.21411C-0.110922 1.6578 -0.110922 2.37452 0.332765 2.81821L5.89591 8.38135L0.332765 13.9445C-0.110922 14.3882 -0.110922 15.1049 0.332765 15.5486C0.776451 15.9923 1.49317 15.9923 1.93686 15.5486L7.5 9.98544L13.0631 15.5486C13.5068 15.9923 14.2235 15.9923 14.6672 15.5486C15.1109 15.1049 15.1109 14.3882 14.6672 13.9445L9.1041 8.38135L14.6672 2.81821C15.0995 2.3859 15.0995 1.6578 14.6672 1.22549Z' fill='%23000'/%3E%3C/svg%3E%0A");
    }

ol > li {
  padding-left:2.25rem;
  counter-increment:ol-counter;
}

ol > li::before {
  position:absolute;
}

ol > li::before {
  left:0px;
}

ol > li::before {
  display:block;
}

ol > li::before {
  font-weight:var(--fw-bold);
}

ol > li::before {
  color:var(--primary-green);
}

ol > li::before{
    content:'0' counter(ol-counter);
  }

ol > li:nth-child(n + 10)::before{
    content:counter(ol-counter);
  }

hr {
  margin-bottom:1.75rem;
  display:block;
  width:100%;
  border-width:0px;
  border-bottom-width:1px;
  border-style:solid;
}

blockquote {
  position:relative;
  margin-left:0px;
  margin-right:0px;
  margin-bottom:1rem;
  margin-top:2.25rem;
  border-width:1px;
  border-style:solid;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:2.5rem;
  padding-bottom:1.25rem;
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}

@media (min-width: 768px) {

  blockquote {
    padding-left:2.5rem;
    padding-right:2.5rem;
  }

  blockquote {
    padding-bottom:2rem;
  }
}

@media (min-width: 1024px) {

  blockquote {
    margin-bottom:2rem;
  }

  blockquote {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
}

blockquote::before {
  display:block;
}

blockquote::before {
  height:4rem;
}

blockquote::before {
  width:7rem;
}

blockquote::before {
  background-repeat:no-repeat;
}

@media (min-width: 768px) {

  blockquote::before {
    width:8rem;
  }
}

blockquote::before{

    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 116 50.73' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath fill='%23ffffff00' d='M-20-18h160v89H-20z'%3E%3C/path%3E%3Cpath d='M71.019 50.432c-.438.295-1.532.555-2.172-.155l-1.182-1.487c-.573-.967.12-1.865.567-2.25 2.133-1.766 3.682-3.133 4.648-4.103 1.897-2 3.3-4 4.227-5.98.21-.456-.33-.75-.61-.838C69.499 33.329 66 29.29 66 23.505c0-3.41 1.132-6.178 3.397-8.307 2.264-2.13 5.096-3.195 8.497-3.197 3.052.008 5.745 1.397 8.078 4.166 2.299 2.616 3.448 5.439 3.446 8.468 0 8.897-6.133 17.496-18.4 25.797zm26.602 0c-.438.295-1.533.555-2.172-.155l-1.182-1.487c-.573-.967.119-1.865.567-2.25 2.131-1.766 3.68-3.133 4.648-4.103 1.897-2 3.299-4 4.227-5.98.21-.456-.33-.75-.61-.838-6.998-2.29-10.497-6.327-10.497-12.114 0-3.41 1.132-6.178 3.396-8.307 2.265-2.13 5.097-3.195 8.498-3.197 3.037 0 5.727 1.385 8.068 4.154 2.292 2.609 3.438 5.43 3.436 8.467.013 8.906-6.113 17.51-18.379 25.81zM44.981.3c.438-.295 1.533-.555 2.172.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.133 1.766-3.682 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838C46.501 17.403 50 21.44 50 27.227c0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.052-.01-5.745-1.398-8.078-4.167-2.299-2.616-3.448-5.438-3.446-8.467C26.582 17.2 32.715 8.6 44.982.3zM18.38.3c.437-.295 1.531-.555 2.171.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.13 1.766-3.68 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838 6.998 2.289 10.497 6.327 10.497 12.113 0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.037 0-5.727-1.385-8.068-4.154C1.144 31.968-.002 29.146 0 26.11-.013 17.205 6.113 8.6 18.38.3z' fill='%23000'%3E%3C/path%3E%3C/svg%3E");
    content:'';
  }

blockquote .author {
  margin-bottom:0.5rem;
}

blockquote .author {
  display:inline-flex;
}

blockquote .author {
  align-items:center;
}

blockquote .author {
  gap:0.5rem;
}

blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

blockquote .author::before {
  display:inline-block;
}

blockquote .author::before {
  height:0.25rem;
}

blockquote .author::before {
  width:1.25rem;
}

blockquote .author::before {
  border-width:0px;
}

blockquote .author::before {
  border-bottom-width:1px;
}

blockquote .author::before {
  border-style:solid;
}

blockquote .author::before{
      content:'';
    }

table, th, td, thead {
  border-collapse:collapse;
}

.table-wrapper {
  overflow-x:auto;
}

.table-wrapper::-webkit-scrollbar {
  width:0.5rem;
}

.table-wrapper::-webkit-scrollbar-track {
  border-radius:0.5rem;
}

.table-wrapper::-webkit-scrollbar-track {
  border-style:none;
}

.table-wrapper::-webkit-scrollbar-thumb {
  border-radius:0.5rem;
}

table thead {
  border-bottom-width:2px;
}

table thead {
  border-style:solid;
}

table thead {
  border-color:var(--bh-neutral-black);
}

table tbody tr {
  border-bottom-width:1px;
}

table tbody tr {
  border-style:solid;
}

table tbody tr {
  border-color:var(--bh-neutral-default);
}

table tbody [scope='row'] {
  border-right-width:2px;
}

table tbody [scope='row'] {
  border-style:solid;
}

table tbody [scope='row'] {
  border-color:var(--bh-neutral-black);
}

ul.columns-2, ul.columns-3 {
  gap:2rem;

  columns:1;
}

@media (min-width: 768px){
  ul.columns-2{
    columns:2;
  }

  ul.columns-3{
    columns:3;
  }
    ul.columns-2 li, ul.columns-3 li {
    text-align:left;
  }
}

@media (min-width: 768px){
  .columns-2 {
    gap:1.5rem;
  }
  .columns-2{
    columns:2;
  }
    .columns-2 > div {
    margin-bottom:1.5rem;
  }
    .columns-2 > div {
    display:inline-block;
  }
    .columns-2 > div {
    width:100%;
  }
    .columns-2 > div {
    break-inside:avoid;
  }

      .columns-2 > div .label {
    margin-bottom:0.25rem;
  }

      .columns-2 > div .label {
    font-family:var(--ff-display);
  }

      .columns-2 > div .label {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }

      .columns-2 > div .label {
    font-weight:var(--fw-bold);
  }

      .columns-2 > div .label {
    color:var(--primary-blue);
  }
}

.text-align-left{
  text-align:left;
}

.text-align-right{
  text-align:right;
}

.text-align-center{
  text-align:center;
}

.text-align-justify{
  text-align:justify;
}

.align-left {
  float:left;
  padding-right:1rem;
}

.align-right {
  float:right;
  padding-left:1rem;
}

.align-center {
  display:flex;
  align-items:center;
  justify-content:center;
}

.neutral-black {
  color:var(--neutral-black);
}

.dark-blue {
  color:var(--primary-blue);
}

.btn {
  display:inline-flex;
  align-items:center;
}

.btn::after {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.btn::after {
  transition-duration:300ms;
}

.btn:hover::after,
  .btn:focus::after{
    transform:translateX(40%);
  }

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  margin-left:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  display:block;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  height:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  min-height:16px;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  width:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  min-width:16px;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  background-position:center;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after {
  background-repeat:no-repeat;
}

.btn.primary::after, .btn.secondary::after, .btn.cta-dark::after{
      content:'';
    }

.btn.primary::after, .btn.secondary::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='white'%3E%3C/path%3E%3C/svg%3E");
    }

.btn.cta-dark::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='%231561a0'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%23fff'%3E%3C/path%3E%3C/svg%3E");
    }

.btn.cta-dark:hover::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='%231b365d'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%23fff'%3E%3C/path%3E%3C/svg%3E");
      }

ghs-image img{
  box-shadow:var(--brand-shadow);
}

figure ghs-image {
  margin-bottom:1.25rem;
}

figure figcaption {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-style:italic;
  color:var(--neutral-gray);
}

:host([variant='dark']) &--dark, :host([variant='hero']) &--hero {
  color:var(--neutral-white);
}

:host([variant='dark']) &--dark p a:not(.btn), :host([variant='dark']) &--dark li a:not(.btn), :host([variant='hero']) &--hero p a:not(.btn), :host([variant='hero']) &--hero li a:not(.btn) {
  color:var(--neutral-white);
}

:host([variant='dark']) &--dark p a:not(.btn), :host([variant='dark']) &--dark li a:not(.btn), :host([variant='hero']) &--hero p a:not(.btn), :host([variant='hero']) &--hero li a:not(.btn) {
  text-decoration-line:underline;
}

:host([variant='dark']) &--dark p a:not(.btn), :host([variant='dark']) &--dark li a:not(.btn), :host([variant='hero']) &--hero p a:not(.btn), :host([variant='hero']) &--hero li a:not(.btn) {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

:host([variant='dark']) &--dark p a:not(.btn), :host([variant='dark']) &--dark li a:not(.btn), :host([variant='hero']) &--hero p a:not(.btn), :host([variant='hero']) &--hero li a:not(.btn) {
  transition-duration:500ms;
}

:host([variant='dark']) &--dark p a:not(.btn):hover, :host([variant='dark']) &--dark p a:not(.btn):focus, :host([variant='dark']) &--dark li a:not(.btn):hover, :host([variant='dark']) &--dark li a:not(.btn):focus, :host([variant='hero']) &--hero p a:not(.btn):hover, :host([variant='hero']) &--hero p a:not(.btn):focus, :host([variant='hero']) &--hero li a:not(.btn):hover, :host([variant='hero']) &--hero li a:not(.btn):focus {
  background-color:var(--neutral-white);
}

:host([variant='dark']) &--dark p a:not(.btn):hover, :host([variant='dark']) &--dark p a:not(.btn):focus, :host([variant='dark']) &--dark li a:not(.btn):hover, :host([variant='dark']) &--dark li a:not(.btn):focus, :host([variant='hero']) &--hero p a:not(.btn):hover, :host([variant='hero']) &--hero p a:not(.btn):focus, :host([variant='hero']) &--hero li a:not(.btn):hover, :host([variant='hero']) &--hero li a:not(.btn):focus {
  color:var(--primary-blue);
}

:host([variant='dark']) &--dark p a:not(.btn):hover, :host([variant='dark']) &--dark p a:not(.btn):focus, :host([variant='dark']) &--dark li a:not(.btn):hover, :host([variant='dark']) &--dark li a:not(.btn):focus, :host([variant='hero']) &--hero p a:not(.btn):hover, :host([variant='hero']) &--hero p a:not(.btn):focus, :host([variant='hero']) &--hero li a:not(.btn):hover, :host([variant='hero']) &--hero li a:not(.btn):focus {
  text-decoration-line:none;
}

:host([variant='dark']) &--dark .neutral-black, :host([variant='dark']) &--dark .dark-blue, :host([variant='hero']) &--hero .neutral-black, :host([variant='hero']) &--hero .dark-blue {
  color:var(--neutral-white);
}

:host([variant='dark']) &--dark ul:not(.list-x-mark, .list-check-mark) > li:before, :host([variant='hero']) &--hero ul:not(.list-x-mark, .list-check-mark) > li:before {
  background-color:var(--neutral-white);
}

:host([variant='dark']) &--dark ul.list-check-mark > li:before, :host([variant='hero']) &--hero ul.list-check-mark > li:before{
    background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23FFF'/%3E%3C/svg%3E%0A");
  }

:host([variant='dark']) &--dark ol > li::before, :host([variant='hero']) &--hero ol > li::before {
  color:var(--neutral-white);
}

:host([variant='dark']) &--dark .btn.primary, :host([variant='hero']) &--hero .btn.primary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) &--dark .btn.primary, :host([variant='hero']) &--hero .btn.primary {
  color:var(--primary-blue);
}

:host([variant='dark']) &--dark .btn.secondary, :host([variant='hero']) &--hero .btn.secondary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) &--dark .btn.secondary, :host([variant='hero']) &--hero .btn.secondary {
  color:var(--primary-green);
}

:host([variant='dark']) &--dark .btn.primary::after, :host([variant='hero']) &--hero .btn.primary::after{
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%230a2e4c'%3E%3C/path%3E%3C/svg%3E");
  }

:host([variant='dark']) &--dark .btn.secondary::after, :host([variant='hero']) &--hero .btn.secondary::after{
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%2300665e'%3E%3C/path%3E%3C/svg%3E");
  }

:host([variant='dark']) &--dark .btn.cta-dark, :host([variant='dark']) &--dark .btn.cta-dark:hover, :host([variant='hero']) &--hero .btn.cta-dark, :host([variant='hero']) &--hero .btn.cta-dark:hover {
  color:var(--neutral-white);
}

:host([variant='dark']) &--dark .btn.cta-dark::after, :host([variant='dark']) &--dark .btn.cta-dark:hover::after, :host([variant='hero']) &--hero .btn.cta-dark::after, :host([variant='hero']) &--hero .btn.cta-dark:hover::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='white'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%231561a0'%3E%3C/path%3E%3C/svg%3E");
    }

&--small {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

&--small p, &--small h1, &--small h2, &--small h3, &--small h4 {
  margin-bottom:0.5rem;
}

@media (min-width: 1280px) {

  &--small p, &--small h1, &--small h2, &--small h3, &--small h4 {
    margin-bottom:1rem;
  }
}

&--small p, &--small ul > li, &--small ol > li {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

&--small h5, &--small h6 {
  margin-bottom:0.5rem;
}

&--small h1 {
  font-size:var(--fs-h3-small);
  line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

  &--small h1 {
    font-size:var(--fs-h3-medium);
    line-height:var(--lh-h3-medium);
  }
}

@media (min-width: 1024px) {

  &--small h1 {
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}

&--small h2 {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

  &--small h2 {
    font-size:var(--fs-h4-medium);
    line-height:var(--lh-h4-medium);
  }
}

@media (min-width: 1024px) {

  &--small h2 {
    font-size:var(--fs-h4);
    line-height:var(--lh-h4);
  }
}

&--small h3 {
  font-size:var(--fs-h5-small);
  line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

  &--small h3 {
    font-size:var(--fs-h5-medium);
    line-height:var(--lh-h5-medium);
  }
}

@media (min-width: 1024px) {

  &--small h3 {
    font-size:var(--fs-h5);
    line-height:var(--lh-h5);
  }
}

&--small h4 {
  font-size:var(--fs-h6-small);
  line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

  &--small h4 {
    font-size:var(--fs-h6-medium);
    line-height:var(--lh-h6-medium);
  }
}

@media (min-width: 1024px) {

  &--small h4 {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }
}

&--small h5 {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

&--small h6 {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

&--small blockquote {
  margin-left:0px;
  margin-right:0px;
}

&--small blockquote {
  margin-bottom:1rem;
}

&--small blockquote {
  margin-top:2.25rem;
}

&--small blockquote {
  padding-left:1.25rem;
  padding-right:1.25rem;
}

&--small blockquote {
  padding-top:2.5rem;
}

&--small blockquote {
  padding-bottom:1.25rem;
}

&--small blockquote {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

@media (min-width: 1024px) {

  &--small blockquote {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

&--small blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

&--small blockquote::before {
  top:-2rem;
}

&--small blockquote::before {
  left:1.5rem;
}

&--small blockquote::before {
  padding-left:1rem;
  padding-right:1rem;
}

&--small blockquote::before {
  display:block;
}

&--small blockquote::before {
  height:4rem;
}

&--small blockquote::before {
  width:7rem;
}

&--small blockquote::before{

      background-size:60%;
    }

&--base {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

&--base ul > li, &--base ol > li {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

&--show-more .content {
  height:16rem;
  overflow:hidden;
}

&--show-more&--showing-all .content {
  height:auto;
}

&__actions {
  padding-top:1rem;
}

&__trigger {
  display:flex;
  gap:0.5rem;
  font-family:var(--ff-display);
  font-weight:var(--fw-semibold);
  color:var(--primary-blue-light-2);
}

&--showing-all &__actions {
  margin-top:-2rem;
}

.btn {
  display:inline-flex;
  cursor:pointer;
  align-items:center;
  border-radius:10px;
  border-width:0px;
  font-weight:var(--fw-semibold);
  line-height:1.25;
  text-decoration-line:none;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  min-width:44px;
}

.btn:focus{
    outline-width:1px;
    outline-style:dashed;
    outline-offset:4px;
  }

.btn:not(.cta-dark, .cta-light) {
  background-color:var(--bh-neutral-light);
}

.btn:not(.cta-dark, .cta-light) {
  color:var(--bh-neutral-white);
}

.btn:not(.cta-dark, .cta-light):hover, .btn:not(.cta-dark, .cta-light):focus {
  background-color:var(--bh-neutral-default);
}

.btn:not(.cta-dark, .cta-light):focus {
  outline-color:var(--bh-neutral-default);
}

.btn.parent-container-fit {
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
}

.btn.parent-container-fit .left, .btn.parent-container-fit .right {
  margin-bottom:0px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-top:0px;
}

.btn.parent-container-fit.justify-between{
  justify-content:space-between;
}

.btn ghs-icon {
  position:relative;
  margin-left:0.5rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

.btn.chip {
  border-radius:0.375rem;
  border-width:1px;
  border-style:solid;
  font-weight:var(--fw-normal);
}

.btn.chip .right ghs-icon {
  margin-left:0px;
}

.btn.chip:focus {
  outline-style:solid;
}

.btn.chip:focus {
  outline-width:2px;
}

.btn.chip.small {
  height:30px;
}

.btn.chip.small {
  padding-left:0.375rem;
  padding-right:0.375rem;
}

.btn.chip.small {
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

.btn.chip.small .right {
  padding-left:0.5rem;
}

.btn.chip.medium {
  height:37px;
}

.btn.chip.medium {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.btn.chip.medium .right {
  padding-left:0.625rem;
}

.btn.chip.large {
  height:43px;
}

.btn.chip.large {
  padding-left:1rem;
  padding-right:1rem;
}

.btn.chip.large .right {
  padding-left:0.75rem;
}

.btn.none {
  display:flex;
  align-items:center;
  padding-left:1rem;
  padding-right:1rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.left {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
}

.top {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
  padding-bottom:0.5rem;
}

.right {
  display:flex;
  height:100%;
  align-items:center;
  padding-left:0.5rem;
}

.btn[aria-disabled='true'] {
  pointer-events:none !important;
  cursor:not-allowed !important;
  background-color:var(--neutral-gray-4) !important;
  color:var(--neutral-gray-1) !important;
}

.btn.small {
  max-height:45px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.medium {
  max-height:55px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.large {
  min-height:45px;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px) {

  .btn.large {
    min-height:max-content;
  }

  .btn.large {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.large {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.large {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.btn.xl {
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {

  .btn.xl {
    min-height:max-content;
  }

  .btn.xl {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.xl {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.xl {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.btn.cta-dark.small, .btn.cta-light.small, .btn.cta-dark.large, .btn.cta-light.large {
  padding:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  min-height:auto;
}

.btn:has(> .top) {
  flex-direction:column;
  align-items:center;
  text-align:center;
}

.btn {
  font-family:var(--ff-display);
}

.btn.primary, .btn.secondary, .btn.tertiary, .btn.quaternary {
  transition-property:box-shadow;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.btn.primary:hover, .btn.secondary:hover, .btn.tertiary:hover, .btn.quaternary:hover{
    box-shadow:var(--brand-shadow-sm);
  }

.btn.primary {
  background-color:var(--primary-blue-light-2);
  color:var(--neutral-white);
}

.btn.primary:hover, .btn.primary:focus {
  background-color:var(--primary-blue-light-2);
}

.btn.primary:hover, .btn.primary:focus {
  color:var(--neutral-white);
}

.btn.primary:focus {
  outline-color:var(--primary-blue-light-2);
}

.btn.secondary {
  background-color:var(--primary-green);
  color:var(--neutral-white);
}

.btn.secondary:hover, .btn.secondary:focus {
  background-color:var(--primary-green);
}

.btn.secondary:hover, .btn.secondary:focus {
  color:var(--neutral-white);
}

.btn.secondary:focus {
  outline-color:var(--primary-green);
}

.btn.tertiary {
  background-color:var(--neutral-white);
  color:var(--primary-blue);
}

.btn.tertiary:focus {
  outline-color:var(--neutral-white);
}

.btn.cta-dark {
  background-color:var(--neutral-transparent);
  text-align:left;
  color:var(--primary-blue-light-2);
}

.btn.cta-dark:hover, .btn.cta-dark:focus {
  background-color:var(--neutral-transparent);
}

.btn.cta-dark:hover, .btn.cta-dark:focus {
  color:var(--primary-blue-light-2);
}

.btn.cta-dark:hover, .btn.cta-dark:focus {
  text-decoration-line:underline;
}

.btn.cta-dark:focus {
  outline-color:var(--primary-blue-light-2);
}

.btn.cta-light {
  background-color:var(--neutral-transparent);
  text-align:left;
  color:var(--neutral-white);
}

.btn.cta-light:hover, .btn.cta-light:focus {
  background-color:var(--neutral-transparent);
}

.btn.cta-light:hover, .btn.cta-light:focus {
  color:var(--neutral-white);
}

.btn.cta-light:hover, .btn.cta-light:focus {
  text-decoration-line:underline;
}

.btn.cta-light:focus {
  outline-color:var(--neutral-white);
}

.btn.quaternary {
  background-color:var(--neutral-white);
}

.btn.quaternary.border-white {
  border-width:1px;
  border-style:solid;
  border-color:var(--neutral-white);
}

.btn.quaternary.border-white:focus {
  outline-color:var(--neutral-white);
}

.btn.quaternary.border-blue {
  border-width:1px;
  border-style:solid;
  border-color:var(--primary-blue-light-2);
  color:var(--primary-blue);
}

.btn.quaternary.border-blue:focus {
  outline-color:var(--primary-blue-light-2);
}

.btn.quaternary.border-magenta {
  border-width:1px;
  border-style:solid;
  border-color:var(--tertiary-magenta);
  color:var(--tertiary-magenta);
}

.btn.quaternary.border-magenta:focus {
  outline-color:var(--tertiary-magenta);
}

.btn.quaternary.border-green {
  border-width:1px;
  border-style:solid;
  border-color:var(--primary-green);
  color:var(--primary-green);
}

.btn.quaternary.border-green:focus {
  outline-color:var(--primary-green);
}

.btn.tertiary.text-white {
  color:var(--neutral-white);
}

.btn.tertiary.text-blue {
  color:var(--primary-blue-light-2);
}

.btn.tertiary.text-magenta {
  color:var(--tertiary-magenta);
}

.btn.tertiary.text-green {
  color:var(--primary-green);
}

.btn.primary.border-square {
  min-height:6.5rem;
  border-radius:0px;
  border-width:2px;
  border-style:solid;
  border-color:var(--neutral-white);
  background-color:var(--primary-blue);
}

@media (min-width: 768px) {

  .btn.primary.border-square {
    min-height:7.5rem;
  }
}

.btn.primary.border-square:hover {
  text-decoration-line:underline;
}

:host {
  display:block;
}

.styled-text {
  overflow-wrap:break-word;
}

@media (min-width: 768px) {

  .styled-text {
    overflow-wrap:normal;
    word-break:normal;
  }
}

.styled-text p, .styled-text h1, .styled-text h2, .styled-text h3, .styled-text h4, .styled-text ul, .styled-text ol, .styled-text ghs-image, .styled-text figure, .styled-text table {
  margin-bottom:1rem;
}

@media (min-width: 1280px) {

  .styled-text p, .styled-text h1, .styled-text h2, .styled-text h3, .styled-text h4, .styled-text ul, .styled-text ol, .styled-text ghs-image, .styled-text figure, .styled-text table {
    margin-bottom:2rem;
  }
}

.styled-text h1, .styled-text h2, .styled-text h3, .styled-text h4 {
  font-weight:var(--fw-bold);
}

.styled-text h5, .styled-text h6 {
  margin-bottom:1rem;
}

.styled-text h5, .styled-text h6 {
  font-weight:var(--fw-bold);
}

.styled-text a:not(.btn), .styled-text p a:not(.btn), .styled-text li a:not(.btn) {
  text-decoration-line:underline;
}

.styled-text a:not(.btn), .styled-text p a:not(.btn), .styled-text li a:not(.btn) {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.styled-text a:not(.btn), .styled-text p a:not(.btn), .styled-text li a:not(.btn) {
  transition-duration:500ms;
}

.styled-text a:not(.btn):hover, .styled-text a:not(.btn):focus, .styled-text p a:not(.btn):hover, .styled-text p a:not(.btn):focus, .styled-text li a:not(.btn):hover, .styled-text li a:not(.btn):focus {
  text-decoration-line:none;
}

.styled-text ol, .styled-text ul {
  list-style-type:none;
}

.styled-text ol,
  .styled-text ul{
    counter-reset:ol-counter;
  }

.styled-text ul ul, .styled-text ol ol, .styled-text ul ol, .styled-text ol ul {
  margin-top:0.5rem;
}

@media (min-width: 1024px) {

  .styled-text ul ul, .styled-text ol ol, .styled-text ul ol, .styled-text ol ul {
    margin-top:1rem;
  }
}

.styled-text ul > li {
  padding-left:1.25rem;
}

.styled-text ul > li, .styled-text ol > li {
  position:relative;
}

.styled-text ul > li, .styled-text ol > li {
  margin-bottom:.35rem;
}

@media (min-width: 1024px) {

  .styled-text ul > li, .styled-text ol > li {
    margin-bottom:0.5rem;
  }
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  position:absolute;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  top:0.5rem;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  left:0px;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  margin-right:0.75rem;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  display:block;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  height:0.5rem;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  width:0.5rem;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before {
  border-radius:9999px;
}

.styled-text ul:not(.list-x-mark, .list-check-mark) > li:before{
    content:'';
  }

.styled-text li > ul, .styled-text li > ol {
  margin-bottom:0px;
}

.styled-text ul.list-check-mark > li {
  padding-left:2.25rem;
}

.styled-text ul.list-check-mark > li:before {
  position:absolute;
}

.styled-text ul.list-check-mark > li:before {
  top:0.25rem;
}

.styled-text ul.list-check-mark > li:before {
  left:0px;
}

.styled-text ul.list-check-mark > li:before {
  display:block;
}

.styled-text ul.list-check-mark > li:before {
  height:1.5rem;
}

.styled-text ul.list-check-mark > li:before {
  width:1.5rem;
}

.styled-text ul.list-check-mark > li:before {
  background-repeat:no-repeat;
}

.styled-text ul.list-check-mark > li:before{

        content:'';
        background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23000'/%3E%3C/svg%3E%0A");
      }

.styled-text ul.list-x-mark > li {
  padding-left:1.75rem;
}

.styled-text ul.list-x-mark > li:before {
  position:absolute;
}

.styled-text ul.list-x-mark > li:before {
  top:0.25rem;
}

.styled-text ul.list-x-mark > li:before {
  left:0px;
}

.styled-text ul.list-x-mark > li:before {
  display:block;
}

.styled-text ul.list-x-mark > li:before {
  height:1.5rem;
}

.styled-text ul.list-x-mark > li:before {
  width:1.5rem;
}

.styled-text ul.list-x-mark > li:before {
  background-repeat:no-repeat;
}

.styled-text ul.list-x-mark > li:before{

        content:'';
        background-image:url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6672 1.22549C14.2235 0.781803 13.5068 0.781803 13.0631 1.22549L7.5 6.77725L1.93686 1.21411C1.49317 0.770426 0.776451 0.770426 0.332765 1.21411C-0.110922 1.6578 -0.110922 2.37452 0.332765 2.81821L5.89591 8.38135L0.332765 13.9445C-0.110922 14.3882 -0.110922 15.1049 0.332765 15.5486C0.776451 15.9923 1.49317 15.9923 1.93686 15.5486L7.5 9.98544L13.0631 15.5486C13.5068 15.9923 14.2235 15.9923 14.6672 15.5486C15.1109 15.1049 15.1109 14.3882 14.6672 13.9445L9.1041 8.38135L14.6672 2.81821C15.0995 2.3859 15.0995 1.6578 14.6672 1.22549Z' fill='%23000'/%3E%3C/svg%3E%0A");
      }

.styled-text ol > li {
  padding-left:2.25rem;
}

.styled-text ol > li{
    counter-increment:ol-counter;
  }

.styled-text ol > li::before {
  position:absolute;
}

.styled-text ol > li::before {
  left:0px;
}

.styled-text ol > li::before {
  display:block;
}

.styled-text ol > li::before {
  font-weight:var(--fw-bold);
}

.styled-text ol > li::before {
  color:var(--primary-green);
}

.styled-text ol > li::before{
      content:'0' counter(ol-counter);
    }

.styled-text ol > li:nth-child(n + 10)::before{
      content:counter(ol-counter);
    }

.styled-text hr {
  margin-bottom:1.75rem;
}

.styled-text hr {
  display:block;
}

.styled-text hr {
  width:100%;
}

.styled-text hr {
  border-width:0px;
}

.styled-text hr {
  border-bottom-width:1px;
}

.styled-text hr {
  border-style:solid;
}

.styled-text blockquote {
  position:relative;
}

.styled-text blockquote {
  margin-left:0px;
  margin-right:0px;
}

.styled-text blockquote {
  margin-bottom:1rem;
}

.styled-text blockquote {
  margin-top:2.25rem;
}

.styled-text blockquote {
  border-width:1px;
}

.styled-text blockquote {
  border-style:solid;
}

.styled-text blockquote {
  padding-left:1.25rem;
  padding-right:1.25rem;
}

.styled-text blockquote {
  padding-top:2.5rem;
}

.styled-text blockquote {
  padding-bottom:1.25rem;
}

.styled-text blockquote {
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}

@media (min-width: 768px) {

  .styled-text blockquote {
    padding-left:2.5rem;
    padding-right:2.5rem;
  }
}

@media (min-width: 768px) {

  .styled-text blockquote {
    padding-bottom:2rem;
  }
}

@media (min-width: 1024px) {

  .styled-text blockquote {
    margin-bottom:2rem;
  }
}

@media (min-width: 1024px) {

  .styled-text blockquote {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
}

.styled-text blockquote::before {
  display:block;
}

.styled-text blockquote::before {
  height:4rem;
}

.styled-text blockquote::before {
  width:7rem;
}

.styled-text blockquote::before {
  background-repeat:no-repeat;
}

@media (min-width: 768px) {

  .styled-text blockquote::before {
    width:8rem;
  }
}

.styled-text blockquote::before{

      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 116 50.73' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath fill='%23ffffff00' d='M-20-18h160v89H-20z'%3E%3C/path%3E%3Cpath d='M71.019 50.432c-.438.295-1.532.555-2.172-.155l-1.182-1.487c-.573-.967.12-1.865.567-2.25 2.133-1.766 3.682-3.133 4.648-4.103 1.897-2 3.3-4 4.227-5.98.21-.456-.33-.75-.61-.838C69.499 33.329 66 29.29 66 23.505c0-3.41 1.132-6.178 3.397-8.307 2.264-2.13 5.096-3.195 8.497-3.197 3.052.008 5.745 1.397 8.078 4.166 2.299 2.616 3.448 5.439 3.446 8.468 0 8.897-6.133 17.496-18.4 25.797zm26.602 0c-.438.295-1.533.555-2.172-.155l-1.182-1.487c-.573-.967.119-1.865.567-2.25 2.131-1.766 3.68-3.133 4.648-4.103 1.897-2 3.299-4 4.227-5.98.21-.456-.33-.75-.61-.838-6.998-2.29-10.497-6.327-10.497-12.114 0-3.41 1.132-6.178 3.396-8.307 2.265-2.13 5.097-3.195 8.498-3.197 3.037 0 5.727 1.385 8.068 4.154 2.292 2.609 3.438 5.43 3.436 8.467.013 8.906-6.113 17.51-18.379 25.81zM44.981.3c.438-.295 1.533-.555 2.172.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.133 1.766-3.682 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838C46.501 17.403 50 21.44 50 27.227c0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.052-.01-5.745-1.398-8.078-4.167-2.299-2.616-3.448-5.438-3.446-8.467C26.582 17.2 32.715 8.6 44.982.3zM18.38.3c.437-.295 1.531-.555 2.171.154l1.182 1.488c.573.967-.12 1.864-.567 2.249-2.13 1.766-3.68 3.134-4.648 4.104-1.897 1.999-3.3 3.998-4.227 5.98-.21.455.33.75.61.838 6.998 2.289 10.497 6.327 10.497 12.113 0 3.41-1.132 6.179-3.397 8.308-2.264 2.13-5.096 3.195-8.497 3.197-3.037 0-5.727-1.385-8.068-4.154C1.144 31.968-.002 29.146 0 26.11-.013 17.205 6.113 8.6 18.38.3z' fill='%23000'%3E%3C/path%3E%3C/svg%3E");
      content:'';
    }

.styled-text blockquote .author {
  margin-bottom:0.5rem;
}

.styled-text blockquote .author {
  display:inline-flex;
}

.styled-text blockquote .author {
  align-items:center;
}

.styled-text blockquote .author {
  gap:0.5rem;
}

.styled-text blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.styled-text blockquote .author::before {
  display:inline-block;
}

.styled-text blockquote .author::before {
  height:0.25rem;
}

.styled-text blockquote .author::before {
  width:1.25rem;
}

.styled-text blockquote .author::before {
  border-width:0px;
}

.styled-text blockquote .author::before {
  border-bottom-width:1px;
}

.styled-text blockquote .author::before {
  border-style:solid;
}

.styled-text blockquote .author::before{
        content:'';
      }

.styled-text table, .styled-text th, .styled-text td, .styled-text thead {
  border-collapse:collapse;
}

.styled-text .table-wrapper {
  overflow-x:auto;
}

.styled-text .table-wrapper::-webkit-scrollbar {
  width:0.5rem;
}

.styled-text .table-wrapper::-webkit-scrollbar-track {
  border-radius:0.5rem;
}

.styled-text .table-wrapper::-webkit-scrollbar-track {
  border-style:none;
}

.styled-text .table-wrapper::-webkit-scrollbar-thumb {
  border-radius:0.5rem;
}

.styled-text table thead {
  border-bottom-width:2px;
}

.styled-text table thead {
  border-style:solid;
}

.styled-text table thead {
  border-color:var(--bh-neutral-black);
}

.styled-text table tbody tr {
  border-bottom-width:1px;
}

.styled-text table tbody tr {
  border-style:solid;
}

.styled-text table tbody tr {
  border-color:var(--bh-neutral-default);
}

.styled-text table tbody [scope='row'] {
  border-right-width:2px;
}

.styled-text table tbody [scope='row'] {
  border-style:solid;
}

.styled-text table tbody [scope='row'] {
  border-color:var(--bh-neutral-black);
}

.styled-text ul.columns-2, .styled-text ul.columns-3 {
  gap:2rem;
}

.styled-text ul.columns-2,
  .styled-text ul.columns-3{

    columns:1;
  }

@media (min-width: 768px){
    .styled-text ul.columns-2{
      columns:2;
    }

    .styled-text ul.columns-3{
      columns:3;
    }
      .styled-text ul.columns-2 li, .styled-text ul.columns-3 li {
    text-align:left;
  }
  }

@media (min-width: 768px){
    .styled-text .columns-2 {
    gap:1.5rem;
  }
    .styled-text .columns-2{
      columns:2;
    }
      .styled-text .columns-2 > div {
    margin-bottom:1.5rem;
  }
      .styled-text .columns-2 > div {
    display:inline-block;
  }
      .styled-text .columns-2 > div {
    width:100%;
  }
      .styled-text .columns-2 > div {
    break-inside:avoid;
  }

        .styled-text .columns-2 > div .label {
    margin-bottom:0.25rem;
  }

        .styled-text .columns-2 > div .label {
    font-family:var(--ff-display);
  }

        .styled-text .columns-2 > div .label {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }

        .styled-text .columns-2 > div .label {
    font-weight:var(--fw-bold);
  }

        .styled-text .columns-2 > div .label {
    color:var(--primary-blue);
  }
  }

.styled-text .text-align-left{
    text-align:left;
  }

.styled-text .text-align-right{
    text-align:right;
  }

.styled-text .text-align-center{
    text-align:center;
  }

.styled-text .text-align-justify{
    text-align:justify;
  }

.styled-text .align-left {
  float:left;
}

.styled-text .align-left {
  padding-right:1rem;
}

.styled-text .align-right {
  float:right;
}

.styled-text .align-right {
  padding-left:1rem;
}

.styled-text .align-center {
  display:flex;
}

.styled-text .align-center {
  align-items:center;
}

.styled-text .align-center {
  justify-content:center;
}

.styled-text .neutral-black {
  color:var(--neutral-black);
}

.styled-text .dark-blue {
  color:var(--primary-blue);
}

.styled-text .btn {
  display:inline-flex;
}

.styled-text .btn {
  align-items:center;
}

.styled-text .btn::after {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.styled-text .btn::after {
  transition-duration:300ms;
}

.styled-text .btn:hover::after,
    .styled-text .btn:focus::after{
      transform:translateX(40%);
    }

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  margin-left:1rem;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  display:block;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  height:1rem;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  min-height:16px;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  width:1rem;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  min-width:16px;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  background-position:center;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after {
  background-repeat:no-repeat;
}

.styled-text .btn.primary::after, .styled-text .btn.secondary::after, .styled-text .btn.cta-dark::after{
        content:'';
      }

.styled-text .btn.primary::after, .styled-text .btn.secondary::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='white'%3E%3C/path%3E%3C/svg%3E");
      }

.styled-text .btn.cta-dark::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='%231561a0'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%23fff'%3E%3C/path%3E%3C/svg%3E");
      }

.styled-text .btn.cta-dark:hover::after{
          background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='%231b365d'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%23fff'%3E%3C/path%3E%3C/svg%3E");
        }

.styled-text ghs-image img{
    box-shadow:var(--brand-shadow);
  }

.styled-text figure ghs-image {
  margin-bottom:1.25rem;
}

.styled-text figure figcaption {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.styled-text figure figcaption {
  font-style:italic;
}

.styled-text figure figcaption {
  color:var(--neutral-gray);
}

:host([variant='dark']) .styled-text--dark, :host([variant='hero']) .styled-text--hero {
  color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark p a:not(.btn), :host([variant='dark']) .styled-text--dark li a:not(.btn), :host([variant='hero']) .styled-text--hero p a:not(.btn), :host([variant='hero']) .styled-text--hero li a:not(.btn) {
  color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark p a:not(.btn), :host([variant='dark']) .styled-text--dark li a:not(.btn), :host([variant='hero']) .styled-text--hero p a:not(.btn), :host([variant='hero']) .styled-text--hero li a:not(.btn) {
  text-decoration-line:underline;
}

:host([variant='dark']) .styled-text--dark p a:not(.btn), :host([variant='dark']) .styled-text--dark li a:not(.btn), :host([variant='hero']) .styled-text--hero p a:not(.btn), :host([variant='hero']) .styled-text--hero li a:not(.btn) {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

:host([variant='dark']) .styled-text--dark p a:not(.btn), :host([variant='dark']) .styled-text--dark li a:not(.btn), :host([variant='hero']) .styled-text--hero p a:not(.btn), :host([variant='hero']) .styled-text--hero li a:not(.btn) {
  transition-duration:500ms;
}

:host([variant='dark']) .styled-text--dark p a:not(.btn):hover, :host([variant='dark']) .styled-text--dark p a:not(.btn):focus, :host([variant='dark']) .styled-text--dark li a:not(.btn):hover, :host([variant='dark']) .styled-text--dark li a:not(.btn):focus, :host([variant='hero']) .styled-text--hero p a:not(.btn):hover, :host([variant='hero']) .styled-text--hero p a:not(.btn):focus, :host([variant='hero']) .styled-text--hero li a:not(.btn):hover, :host([variant='hero']) .styled-text--hero li a:not(.btn):focus {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark p a:not(.btn):hover, :host([variant='dark']) .styled-text--dark p a:not(.btn):focus, :host([variant='dark']) .styled-text--dark li a:not(.btn):hover, :host([variant='dark']) .styled-text--dark li a:not(.btn):focus, :host([variant='hero']) .styled-text--hero p a:not(.btn):hover, :host([variant='hero']) .styled-text--hero p a:not(.btn):focus, :host([variant='hero']) .styled-text--hero li a:not(.btn):hover, :host([variant='hero']) .styled-text--hero li a:not(.btn):focus {
  color:var(--primary-blue);
}

:host([variant='dark']) .styled-text--dark p a:not(.btn):hover, :host([variant='dark']) .styled-text--dark p a:not(.btn):focus, :host([variant='dark']) .styled-text--dark li a:not(.btn):hover, :host([variant='dark']) .styled-text--dark li a:not(.btn):focus, :host([variant='hero']) .styled-text--hero p a:not(.btn):hover, :host([variant='hero']) .styled-text--hero p a:not(.btn):focus, :host([variant='hero']) .styled-text--hero li a:not(.btn):hover, :host([variant='hero']) .styled-text--hero li a:not(.btn):focus {
  text-decoration-line:none;
}

:host([variant='dark']) .styled-text--dark .neutral-black, :host([variant='dark']) .styled-text--dark .dark-blue, :host([variant='hero']) .styled-text--hero .neutral-black, :host([variant='hero']) .styled-text--hero .dark-blue {
  color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark ul:not(.list-x-mark, .list-check-mark) > li:before, :host([variant='hero']) .styled-text--hero ul:not(.list-x-mark, .list-check-mark) > li:before {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark ul.list-check-mark > li:before, :host([variant='hero']) .styled-text--hero ul.list-check-mark > li:before{
      background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23FFF'/%3E%3C/svg%3E%0A");
    }

:host([variant='dark']) .styled-text--dark ol > li::before, :host([variant='hero']) .styled-text--hero ol > li::before {
  color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark .btn.primary, :host([variant='hero']) .styled-text--hero .btn.primary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark .btn.primary, :host([variant='hero']) .styled-text--hero .btn.primary {
  color:var(--primary-blue);
}

:host([variant='dark']) .styled-text--dark .btn.secondary, :host([variant='hero']) .styled-text--hero .btn.secondary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark .btn.secondary, :host([variant='hero']) .styled-text--hero .btn.secondary {
  color:var(--primary-green);
}

:host([variant='dark']) .styled-text--dark .btn.primary::after, :host([variant='hero']) .styled-text--hero .btn.primary::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%230a2e4c'%3E%3C/path%3E%3C/svg%3E");
    }

:host([variant='dark']) .styled-text--dark .btn.secondary::after, :host([variant='hero']) .styled-text--hero .btn.secondary::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%2300665e'%3E%3C/path%3E%3C/svg%3E");
    }

:host([variant='dark']) .styled-text--dark .btn.cta-dark, :host([variant='dark']) .styled-text--dark .btn.cta-dark:hover, :host([variant='hero']) .styled-text--hero .btn.cta-dark, :host([variant='hero']) .styled-text--hero .btn.cta-dark:hover {
  color:var(--neutral-white);
}

:host([variant='dark']) .styled-text--dark .btn.cta-dark::after, :host([variant='dark']) .styled-text--dark .btn.cta-dark:hover::after, :host([variant='hero']) .styled-text--hero .btn.cta-dark::after, :host([variant='hero']) .styled-text--hero .btn.cta-dark:hover::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='white'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%231561a0'%3E%3C/path%3E%3C/svg%3E");
      }

.styled-text--small {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.styled-text--small p, .styled-text--small h1, .styled-text--small h2, .styled-text--small h3, .styled-text--small h4 {
  margin-bottom:0.5rem;
}

@media (min-width: 1280px) {

  .styled-text--small p, .styled-text--small h1, .styled-text--small h2, .styled-text--small h3, .styled-text--small h4 {
    margin-bottom:1rem;
  }
}

.styled-text--small p, .styled-text--small ul > li, .styled-text--small ol > li {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.styled-text--small h5, .styled-text--small h6 {
  margin-bottom:0.5rem;
}

.styled-text--small h1 {
  font-size:var(--fs-h3-small);
  line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

  .styled-text--small h1 {
    font-size:var(--fs-h3-medium);
    line-height:var(--lh-h3-medium);
  }
}

@media (min-width: 1024px) {

  .styled-text--small h1 {
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}

.styled-text--small h2 {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

  .styled-text--small h2 {
    font-size:var(--fs-h4-medium);
    line-height:var(--lh-h4-medium);
  }
}

@media (min-width: 1024px) {

  .styled-text--small h2 {
    font-size:var(--fs-h4);
    line-height:var(--lh-h4);
  }
}

.styled-text--small h3 {
  font-size:var(--fs-h5-small);
  line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

  .styled-text--small h3 {
    font-size:var(--fs-h5-medium);
    line-height:var(--lh-h5-medium);
  }
}

@media (min-width: 1024px) {

  .styled-text--small h3 {
    font-size:var(--fs-h5);
    line-height:var(--lh-h5);
  }
}

.styled-text--small h4 {
  font-size:var(--fs-h6-small);
  line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

  .styled-text--small h4 {
    font-size:var(--fs-h6-medium);
    line-height:var(--lh-h6-medium);
  }
}

@media (min-width: 1024px) {

  .styled-text--small h4 {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }
}

.styled-text--small h5 {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.styled-text--small h6 {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.styled-text--small blockquote {
  margin-left:0px;
  margin-right:0px;
}

.styled-text--small blockquote {
  margin-bottom:1rem;
}

.styled-text--small blockquote {
  margin-top:2.25rem;
}

.styled-text--small blockquote {
  padding-left:1.25rem;
  padding-right:1.25rem;
}

.styled-text--small blockquote {
  padding-top:2.5rem;
}

.styled-text--small blockquote {
  padding-bottom:1.25rem;
}

.styled-text--small blockquote {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

@media (min-width: 1024px) {

  .styled-text--small blockquote {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.styled-text--small blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.styled-text--small blockquote::before {
  top:-2rem;
}

.styled-text--small blockquote::before {
  left:1.5rem;
}

.styled-text--small blockquote::before {
  padding-left:1rem;
  padding-right:1rem;
}

.styled-text--small blockquote::before {
  display:block;
}

.styled-text--small blockquote::before {
  height:4rem;
}

.styled-text--small blockquote::before {
  width:7rem;
}

.styled-text--small blockquote::before{

        background-size:60%;
      }

.styled-text--base {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

.styled-text--base ul > li, .styled-text--base ol > li {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

.styled-text--show-more .content {
  height:16rem;
}

.styled-text--show-more .content {
  overflow:hidden;
}

.styled-text--show-more.styled-text--showing-all .content {
  height:auto;
}

.styled-text__actions {
  padding-top:1rem;
}

.styled-text__trigger {
  display:flex;
}

.styled-text__trigger {
  gap:0.5rem;
}

.styled-text__trigger {
  font-family:var(--ff-display);
}

.styled-text__trigger {
  font-weight:var(--fw-semibold);
}

.styled-text__trigger {
  color:var(--primary-blue-light-2);
}

.styled-text--showing-all .styled-text__actions {
  margin-top:-2rem;
}

.content .hours-text {
  padding-top:0.5rem;
}

.content .hours-text {
  color:var(--outline-black);
}
`;